import { render, staticRenderFns } from "./RequiredDataForm.vue?vue&type=template&id=bc3c8864&"
import script from "./RequiredDataForm.vue?vue&type=script&lang=js&"
export * from "./RequiredDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RequiredDataForm.vue"
export default component.exports